/**
 * ImportanceBadge — the F7 change-importance status pill.
 *
 * One badge per classified change (PRD §F7 变更重要度徽章). Colour comes from the
 * importance→tone→token map; never hardcoded.
 */
import * as React from 'react';
import type { ImportanceLevel } from '../../lib/veridoc-api';

import { IMPORTANCE_LABELS } from './constants';
import { IMPORTANCE_TONE, TONE_CLASSES } from './importanceVisual';

export function ImportanceBadge({
  importance,
}: {
  importance: ImportanceLevel;
}): React.JSX.Element {
  const tone = TONE_CLASSES[IMPORTANCE_TONE[importance]];
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-sm border px-2 py-0.5 text-xs font-semibold ${tone.badge}`}
    >
      <span aria-hidden="true" className={`h-1.5 w-1.5 rounded-full ${tone.dot}`} />
      {IMPORTANCE_LABELS[importance]}
    </span>
  );
}

export default ImportanceBadge;
